/**
* @see 1)\client\containers\GiftCard\index.js
* ListFiltersMobile
*/

import React from 'react';
import { bool, string, func, array } from 'prop-types';
import FontAwesomeIcon from 'react-fontawesome';
import { MobileListStyle } from './StyledListFilters';
import { renderFitlers, RenderNestedFilters } from './';
// import Button from '../Button';

function ListFiltersMobile(props) {
  const { filters,
    mainTitle,
    onChange,
    showFilter,
    handleApply,
    payloadKey,
    filterResults,
    isShowSubFilter,
    selectedCategories,
  } = props;
  return (
    <MobileListStyle>
      <div className="header">
        <small>{mainTitle}</small>
        <span className="close" role="presentation" onClick={handleApply}>
          <FontAwesomeIcon name="close" />
        </span>
      </div>
      <div className="wrapperFlex">
        <div className="left">
          <ul>
            {filters.map(({ filterTitle, index, isActive, payloadKey: _payloadKey }) => (
              <li
                key={index}
                className={isActive ? 'active' : ''}
                role="presentation"
                onClick={() => showFilter(_payloadKey, filterTitle)}
              >
                {filterTitle}
              </li>
            ))}
          </ul>
        </div>
        <div className="right">
          <ul>
            {isShowSubFilter ?
              <RenderNestedFilters filters={filterResults} onChange={onChange} payloadKey={payloadKey} selectedCategories={selectedCategories} /> :
              renderFitlers(filterResults, onChange, payloadKey)}
          </ul>
        </div>
      </div>
      {/* <Button type="primary" onClick={handleApply}>Apply</Button> */}
    </MobileListStyle>
  );
}

ListFiltersMobile.defaultProps = {
  handleApply: () => '',
  filters: [],
  selectedCategories: [],
};
ListFiltersMobile.propTypes = {
  isShowSubFilter: bool.isRequired,
  payloadKey: string.isRequired,
  mainTitle: string.isRequired,
  handleApply: func,
  onChange: func.isRequired,
  showFilter: func.isRequired,
  filters: array,
  filterResults: array.isRequired,
  selectedCategories: array,
};

export default ListFiltersMobile;



// WEBPACK FOOTER //
// client/components/ListFilters/indexMobile.js